import {MergeabilityFailureIcon} from '@github-ui/custom-icons/MergeabilityFailureIcon'
import {ForYouItem} from '../shared/ForYouItem'
import {selectFailedRequiredChecks} from './use-failed-checks-data'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'

// The decider tree selects the audience-specific row.
export function FailingChecks() {
  const data = useMergeabilityData()
  if (!data || data.isClosedOrMerged || selectFailedRequiredChecks(data.statusChecks).length === 0) {
    return null
  }

  return (
    <ForYouItem
      itemId="failing-checks"
      visual={{kind: 'icon', icon: MergeabilityFailureIcon, tone: 'danger', glyphSize: 12}}
      title="Required checks failing"
      subText="Fix the failing required checks."
      actions={[
        {
          id: 'merge-when-ready',
          content: <OverviewMergeControl data={data} itemName="failing-checks" />,
        },
      ]}
    />
  )
}
